import { ISelectionItem } from "@app/models/selection-item";

export enum PeriodTypes {
  None = 1,
  Daily,
  Weekly,
  Monthly
}

export enum PeriodTypesDescription {
  None = 'None',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly'
}

export const PeriodItems: ISelectionItem[] = [
  {
    id: PeriodTypes.None,
    description: PeriodTypesDescription.None
  },
  {
    id: PeriodTypes.Daily,
    description: PeriodTypesDescription.Daily
  },
  {
    id: PeriodTypes.Weekly,
    description: PeriodTypesDescription.Weekly
  },
  {
    id: PeriodTypes.Monthly,
    description: PeriodTypesDescription.Monthly
  }
];